<figure class="mc" role="group" [attr.aria-label]="model.ariaLabel" [style.--mc-h.px]="height">
  <div class="mc-y" aria-hidden="true">
    <span class="mc-ytick" *ngFor="let t of model.yTicks; trackBy: track" [style.top.%]="t.y">{{ t.label }}</span>
  </div>

  <div class="mc-plot" (mouseleave)="hover = -1">
    <svg class="metric-chart" viewBox="0 0 100 100" preserveAspectRatio="none" aria-hidden="true">
      <line class="mc-grid" *ngFor="let t of model.yTicks; trackBy: track" x1="0" x2="100" [attr.y1]="t.y" [attr.y2]="t.y"></line>
      <rect
        *ngFor="let b of model.bars; trackBy: track"
        [attr.class]="'mc-bar ' + b.kind"
        [attr.x]="b.x"
        [attr.y]="b.y"
        [attr.width]="b.w"
        [attr.height]="b.h"
      ></rect>
      <path *ngFor="let p of model.paths; trackBy: track" [attr.class]="'mc-path ' + p.kind" [attr.d]="p.d"></path>
      <line class="mc-hline" *ngFor="let h of model.hlines; trackBy: track" x1="0" x2="100" [attr.y1]="h.y" [attr.y2]="h.y"></line>
      <line
        *ngFor="let v of model.vlines; trackBy: track"
        [attr.class]="'mc-vline ' + v.kind"
        y1="0"
        y2="100"
        [attr.x1]="v.x"
        [attr.x2]="v.x"
      ></line>
    </svg>

    <span class="mc-hlabel" *ngFor="let h of model.hlines; trackBy: track" [style.top.%]="h.y" aria-hidden="true">{{ h.label }}</span>
    <span *ngFor="let v of model.vlines; trackBy: track" [class]="'mc-vlabel ' + v.kind" [style.left.%]="v.x" aria-hidden="true">{{
      v.label
    }}</span>

    <ng-container *ngFor="let d of model.dots; trackBy: track">
      <span [class]="'mc-dot ' + d.kind" [style.left.%]="d.x" [style.top.%]="d.y" aria-hidden="true"></span>
      <span *ngIf="d.label" class="mc-dlabel" [class.muted]="d.muted" [style.left.%]="d.x" [style.top.%]="d.y" aria-hidden="true">{{
        d.label
      }}</span>
    </ng-container>

    <!-- Una zona por posición: el hover cambia un índice y el tooltip ya viene escrito. -->
    <span
      class="mc-hit"
      *ngFor="let s of model.slots; let i = index; trackBy: track"
      [class.on]="hover === i"
      [style.left.%]="s.x"
      [style.width.%]="s.w"
      (mouseenter)="hover = i"
      (focus)="hover = i"
      (blur)="hover = -1"
      tabindex="0"
      role="img"
      [attr.aria-label]="s.tip.title + '. ' + s.tip.lines.join('. ')"
    ></span>

    <div
      class="mc-tip"
      *ngIf="hover >= 0 && model.slots[hover] as s"
      [class.left]="tipToLeft(hover)"
      [style.left.%]="tipX(hover)"
      role="tooltip"
    >
      <strong>{{ s.tip.title }}</strong>
      <span *ngFor="let l of s.tip.lines; trackBy: track">{{ l }}</span>
    </div>
  </div>

  <div class="mc-x" aria-hidden="true">
    <span class="mc-xtick" *ngFor="let t of model.xTicks; trackBy: track" [style.left.%]="t.x">{{ t.label }}</span>
  </div>
  <div class="mc-groups" *ngIf="model.xGroups.length" aria-hidden="true">
    <span class="mc-group" *ngFor="let g of model.xGroups; trackBy: track" [style.left.%]="g.x">{{ g.label }}</span>
  </div>
</figure>
